module.exports = __webpack_public_path__ + "images/pro/img-pro-features@2x-c9c4da13500b7784494fb1e7b4f51306.png";